import Axios from "axios";
import { memberV2Urls } from "../urls";
import router from "../../../router";

export default {
	post_public_member(context, data) {
		Axios.post(memberV2Urls.postMemberV2, data)
		.then(function(response) {
			router.push({
			  name: "NewMembershipPayment",
			  params: {
				member_id:data.member_reference_number
			  }
			});
		  })
			.catch(function (error) { });
	},
	post_existing_member(context, data) {
		Axios.post(memberV2Urls.postExistingMemberV2, data)
		  .then(function(response) {
			router.push({
			  name: "Members"
			});
		  })
		  .catch(function(error) {});
	  },
	  update_member(context, data) {
		Axios.post(memberV2Urls.editMemberV2, data).then(function() {
		  context.dispatch("get_member", data.public_id);
		  context.dispatch("get_all_members");
		  router.push({
			name: data.redirect_url
		  });
		});
	  },
	  delete_member(context, data) {
		Axios.post(memberV2Urls.deleteMemberV2 ,data).then(() => {
			router.push({
				name: "Members"
			  });
		});
	  },
}